import arrondiResult from '@/services/general/arrondiCalcul';
import * as typeProduit from '@/configuration/typesProduits';

export function calculTarif(data) {
  data.tarifHT = 0;

  if (!data.facesPrevues || data.facesPrevues === 0 || !data.facesSouhaitees) {
    if (data.facesSouhaitees === 0 && data.tarifHT === 0) {
      data.tarifHT = data.tarifBaseBrut;
      data.tarifNet = data.tarifHT;
    }
    return data;
  }
  if (data.tarifBaseBrut) {
    data.tarifHT = arrondiResult(data.facesSouhaitees * data.tarifBaseBrut / data.facesPrevues);
    data.tarifNet = data.tarifHT;
  }
  if (data.tarifBasePose) {
    data.tarifDePose = arrondiResult(data.tarifBasePose * data.facesSouhaitees / data.facesPrevues);
  }
  if (typeof data.tarifBaseTaxes === 'number') {
    data.taxeMunicipale = arrondiResult(data.tarifBaseTaxes
      * data.facesSouhaitees / data.facesPrevues);
  }
  if (data.tarifBaseNet) {
    data.tarifNet = arrondiResult(data.tarifBaseNet * data.facesSouhaitees / data.facesPrevues);
  }
  return data;
}

export function calculTarifNet(data, value, type) {
  let tarifHT = 0;
  if (type === typeProduit.PANNEAU_LC) tarifHT = data.extensionOpportunite.tarifAnnuel;
  if (type === typeProduit.RESEAU_TEMPO) tarifHT = data.extensionOpportunite.tarifHT;
  if (type === typeProduit.RESEAU_LC) tarifHT = data.extensionOpportunite.tarifBrut;
  if (type === typeProduit.RESEAU_NUMERIQUE) tarifHT = data.tarifBrut;
  if (value) {
    if (data.extensionOpportunite.typeDeRemise === 0) {
      data.extensionOpportunite.tarifNet = arrondiResult(value
        - value
        * data.extensionOpportunite.remise / 100);
    } else {
      data.extensionOpportunite.tarifNet = arrondiResult(value
        - data.extensionOpportunite.remise);
    }
    data.extensionOpportunite.tarifBaseNet = data.extensionOpportunite.tarifNet;
    return null;
  }
  if (data.extensionOpportunite.remise || data.extensionOpportunite.remise === 0) {
    if (!tarifHT) {
      data.extensionOpportunite.remise = 0;
    }
    if (data.extensionOpportunite.typeDeRemise === 0) {
      data.extensionOpportunite.tarifNet = arrondiResult(tarifHT
        - tarifHT
        * data.extensionOpportunite.remise / 100);
    } else {
      data.extensionOpportunite.tarifNet = arrondiResult(tarifHT
        - data.extensionOpportunite.remise);
    }
    data.extensionOpportunite.tarifBaseNet = data.extensionOpportunite.tarifNet;
    return null;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/services/calcul/calculTarif.js